import { Button } from "@mantine/core";
import { Link } from "react-router";
import { useMessages } from "../i18n/provider";
import styles from "./legal.module.css";

export function NotFoundPage() {
  const t = useMessages();
  return (
    <div className={styles.root}>
      <main className={styles.main}>
        <p className={styles.updated}>404</p>
        <h1 className={styles.title}>{t("errors.notFound")}</h1>
        <Button component={Link} to="/" mt="xl">
          {t("app.name")}
        </Button>
      </main>
    </div>
  );
}
